var map = {
	"./amex-logo.svg": "e65d",
	"./apple-pay-logo.svg": "1022",
	"./arrow-down-white.svg": "d783",
	"./circle-dot-regular.svg": "4e04",
	"./coinbase-wallet-logo.png": "5d38",
	"./google-pay.svg": "8915",
	"./icon-foundation.svg": "873c",
	"./icon-looksrare.svg": "ce2a",
	"./icon-nifty.svg": "de41",
	"./icon-opensea.svg": "bc47",
	"./icon-rarible.svg": "56ff",
	"./icon-superrare.svg": "00dd",
	"./icon-twitter.svg": "be9b",
	"./logo_delegate_cash.svg": "3e18",
	"./manifold-logograph.svg": "ff3d",
	"./mastercard-logo.svg": "d96b",
	"./metamask-logo.png": "b5d7",
	"./optimism-logo.svg": "24b7",
	"./twitter-logo.svg": "8700",
	"./visa-logo.svg": "5edc",
	"./walletconnect-logo.png": "3a47"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";